import { render, staticRenderFns } from "./HotelPromotionList.vue?vue&type=template&id=10cdf46a&"
import script from "./HotelPromotionList.vue?vue&type=script&lang=js&"
export * from "./HotelPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./HotelPromotionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports